import { useMutation, useQuery } from "react-query";
import { getCommonSettings, saveCommonSettings } from "src/apis/Setting/setting.api";
import toastHelper from "src/components/Forms/Toastify";
import { TBaseRequestResponse } from "src/types/Commons/baseApiRes.model";
import { TCommonSettingsRequest } from "src/types/Systems/settings.model";
import { printMessage } from "src/utils/commons/errors";

export function useCommonSettings(){
    const queryCommonSettings=useQuery("getCommonSettings",()=>getCommonSettings(),{
      onSuccess:response=>response.succeeded?response.data:null
    })
    const mutationUpdateCommonSettings = useMutation((param: TCommonSettingsRequest) => saveCommonSettings(param), {
        onSuccess: async (response: TBaseRequestResponse<boolean>) => {
          if (response && response.succeeded) {
            const data = response.data;
           if(data) toastHelper.showSuccess("Update successfully");
           else  toastHelper.showSuccess("Update failed");
          }
        },
        onError: (error: any) => {
          printMessage(error.message);
        }
      });
    return{
        mutationUpdateCommonSettings,
        queryCommonSettings
    }
}